import { render, staticRenderFns } from "./RoleIntegrationByCurp.vue?vue&type=template&id=62a1ed98&"
import script from "./RoleIntegrationByCurp.vue?vue&type=script&lang=js&"
export * from "./RoleIntegrationByCurp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports